export const IS_STORYBOOK = typeof window !== 'undefined' && window.IS_STORYBOOK;
export const MOBILE_STICKY_OFFSET = IS_STORYBOOK ? 0 : 60;
/** Height of the app bar notification, published by the app shell so viewport-pinned elements can stick below it. */
export const APP_BAR_NOTIFICATION_HEIGHT_VAR = '--app-bar-notification-height';
export const APP_BAR_NOTIFICATION_OFFSET = `var(${APP_BAR_NOTIFICATION_HEIGHT_VAR}, 0px)`;
